import { PaginationQueryParams } from '../types/pagination';

export const initialPagination: PaginationQueryParams = {
  page: 1,
  pageSize: 25,
};
